import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=725de50d&"
import script from "./payment-method.vue?vue&type=script&lang=ts&"
export * from "./payment-method.vue?vue&type=script&lang=ts&"
import style0 from "./payment-method.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports